import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Grid,
  Image,
  Icon,
} from "@chakra-ui/react";

const CoCreationSection = ({ 
  blueTitle,
  blackTitle,
  subtitle,
  processes,
  illustrationImage,
  footerText
}) => {
  return (
    <Box w="full" py={12} >
      <Container maxW="7xl">
        <VStack spacing={8}>
          {/* Title and Subtitle */}
          <VStack spacing={4} textAlign="center">
            <Heading
              as="h1"
              fontSize={{ base: "2xl", md: "4xl" }}
              fontWeight="bold"
              color="#000B8C"
              lineHeight="1.2"
            >
              {blueTitle}{" "}
              <Text as="span" color="gray.700">
                {blackTitle}
              </Text>
            </Heading>
            <Text 
              fontSize={{ base: "sm", md: "md" }}
              color="gray.600"
              maxW="6xl"
            >
              {subtitle}
            </Text>
          </VStack>

          {/* Main Content Grid */}
          <Grid
            templateColumns={{ base: "1fr", lg: "1fr 1fr" }}
            gap={12}
            alignItems="center"
            w="full"
          >
            {/* Left Content - Process List */}
            <VStack spacing={4} align="start">
              {processes.map((process) => (
                <Box
                  key={process.id}
                  bg="white"
                  p={6}
                  borderRadius="lg"
                  border="1px"
                  borderColor="gray.200"
                  w="full"
                  shadow="sm"
                  transition="all 0.3s ease"
                  _hover={{
                    shadow: "md",
                    borderColor: "blue.200",
                  }}
                >
                  <HStack spacing={3} align="center">
                    {process.icon && (
                      typeof process.icon === 'string' && process.icon.includes('.svg') ? (
                        <Image
                          src={process.icon}
                          alt={process.title || `Process ${process.id}`}
                          boxSize={8}
                          mt={0.5}
                          flexShrink={0}
                        />
                      ) : (
                        <Icon 
                          as={process.icon} 
                          boxSize={5}
                          mt={0.5}
                          flexShrink={0}
                        />
                      )
                    )}
                    <VStack align="start" spacing={1} flex={1}>
                      <Text 
                        fontWeight="bold"
                        color="#000B8C"
                        fontSize="md"
                        lineHeight="1.5"
                      >
                        {process.title}
                      </Text>
                      {process.description && (
                        <Text 
                          fontWeight="normal"
                          color="gray.600"
                          fontSize="sm"
                          lineHeight="1.4"
                        >
                          {process.description}
                        </Text>
                      )}
                    </VStack>
                  </HStack>
                </Box>
              ))}
            </VStack>

            {/* Right Content - Illustration */}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Image
                src={illustrationImage}
                alt="Collaboration Illustration"
                maxW="100%"
                h="auto"
                objectFit="contain"
              />
            </Box>
          </Grid>

          {/* Footer Text */}
          <Text 
            fontSize={{ base: "sm", md: "md" }}
            color="gray.600"
            textAlign="center"
            fontStyle="italic"
            maxW="4xl"
          >
            {footerText}
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default CoCreationSection;